import { useEffect } from "react";
import { Navigation } from "../../components/Navigation/navigation";
import './ngo.css';
import ngo01 from './ngo01.jpg';
import ngo02 from './ngo02.jpg';
export const NGO = ( props ) => {
    useEffect(()=>{
        document.querySelector("body#ruby-rock-app").scrollTop = 0;
    },[])
    return (
        <>
        <Navigation />
        <div id="ngo">
            <div id="ngo-grid">
                <div className="ngo-grid-image">
                    <img src={ngo01} alt="Family of Good Hope" />
                </div>
                <div className="ngo-grid-content">
                    <p>SpecimenLabs will use a percentage of proceeds to donate to two NGOs in Tanzania impacting the lives of women and children and improving local communities by providing healthcare & education.</p>
                    <h2>Family of Good Hope</h2>
                    <p>Family of Good Hope was born out of a long-standing desire and dream to support young women with children in Tanzania.</p>
                    <p>During some trips and social commitments in Ethiopia and Tanzania, I noticed that there are many young single mothers with children.</p>
                    <p>In Tanzania, there is a government regulation that states that as soon as a student becomes pregnant, she must leave school immediately. Since 2015, women have not been allowed to return, even after giving birth. For most young women, this means a life of abject poverty. Some are lucky enough to stay with their families, but many end up on the streets. There is no support for these women.</p>
                    <p>Poverty prevents education, education prevents poverty. A lack of education is one of the main causes of poverty and thus also its greatest consequence. That's why we want to give mothers and their children, young women and girls the opportunity to graduate from school and/or do an apprenticeship.</p>
                    <a href="https://www.familyofgoodhope.org">www.familyofgoodhope.org</a>
                </div>
                <div className="ngo-grid-content">
                    <br/><br/><br/>
                    <h2>HalevAfrica</h2>
                    <p>HalevAfrica is an NGO, non-profit, non-religious and non-political organization that was founded in 2019 with the objective of locating orphans and abandoned children ages 4-12 from remote villages in Tanzania and guarantee them access to quality education, food and health care while monitoring their progress along the way.</p>
                    <p>Our goal is to give orphans / abandoned children proper education, with full scholarships to quality private schools with a full curriculum, including math, English, art, computer science and more. In that regard, we believe that private education adhering to adequate academic level will allow the children to successfully graduate, and later hold respectable jobs and contribute to their communities, while avoiding life of hunger and poverty. </p>
                    <a href="https://www.halevafrica.com">www.halevafrica.com</a>
                </div>
                <div className="ngo-grid-image">
                    <img src={ngo02} alt="Halev Africa" />
                </div>
            </div>
        </div>
        </>
    )
}